<template>
  <b-container>
    <div class="mb-3">Categoria*:</div>
    <CategorySelect :newTicket="true" :resetear="this.reset"
    @reseted="childVal => {
      this.reset = childVal.reset
    }"
    @changeCategory="childVal => {
      this.category = childVal !== null ? childVal.id : null
    }"/>
    <div class="mb-3">Subcategoria*:</div>
    <GroupSelect :newTicket="true" :category="category"
    @changeGroup="childVal => {
      this.group = childVal !== null ? childVal.id : null
    }"/>
    <div class="mb-3">Incidencia*:</div>
    <IncidenceSelect :newTicket="true" :group="group"
    @changeIncidence="childVal => {
      this.incidence = childVal !== null ? childVal.id : null
    }"/>
  </b-container>
</template>

<script>
import CategorySelect from '@/components/CategorySelect'
import GroupSelect from '@/components/GroupSelect'
import IncidenceSelect from '@/components/IncidenceSelect'

export default {
  components: {
    CategorySelect,
    GroupSelect,
    IncidenceSelect
  },
  props: {
    reset: {
      required: false,
      type: Boolean
    }
  },
  data () {
    return this.getDefaultData()
  },
  methods: {
    getDefaultData () {
      return {
        // Información escogida por el usuario
        category: null,
        group: null,
        incidence: null
      }
    }
  },
  watch: {
    reset: function (newVal) {
      Object.assign(this.$data, this.getDefaultData())
      this.$emit('reseted', {
        reset: false
      })
    },
    // En el momento que elige una incidencia aviso al parent para que pille la info
    incidence: function (newVal) {
      this.$emit('changeIncidence', {
        incidence: newVal
      })
    },
    category: function (newVal) {
      this.$emit('changeCategory', {
        category: newVal
      })
    }
  }
}
</script>

<style scoped>

</style>
